export default __webpack_public_path__ + "019dfe45d89fece3f1eb4d512ea549ea.png";